/**
 * ConnectionIcon
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'utils/cx.js';
import Icon2 from '../../media/Icon2/index.js';
import { EXTERNAL_PROVIDERS } from './constants.js';

function ConnectionIcon({ providerId, className, ...props }) {
  const conn = EXTERNAL_PROVIDERS[providerId];
  return <Icon2 className={cx(conn.icon, 'auto-color', className)} aria-label={conn.label} {...props} />;
}

ConnectionIcon.propTypes = {
  providerId: PropTypes.number,
  className: PropTypes.string,
};

export default ConnectionIcon;
